import Events from '@components/events';

const EventsComponent = () => {
  return <Events />;
};

export default EventsComponent;
